import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

export const insurancePolicyDetailQueryKey = (policyId: string) => ['insurancePolicy', policyId];

export const useInsurancePolicyDetail = (
  policyId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: insurancePolicyDetailQueryKey(policyId ?? ''),
    queryFn: () => insuranceRepository.getInsurancePolicy(policyId ?? ''),
    enabled: !!policyId && enabled
  });
};

export const usePrefetchInsurancePolicyDetail = () => {
  const queryClient = useQueryClient();
  const insuranceRepository = InsuranceRepository();

  return useCallback(
    (policyId: string | undefined) => {
      if (!policyId) return;

      queryClient.prefetchQuery({
        queryKey: insurancePolicyDetailQueryKey(policyId),
        queryFn: () => insuranceRepository.getInsurancePolicy(policyId)
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryClient]
  );
};

export default useInsurancePolicyDetail;
